import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics, logEvent } from "firebase/analytics";
import { getPerformance, FirebasePerformance, PerformanceTrace, trace } from "firebase/performance";
import { getLob } from "./services/authenticationService";

// Define the Firebase configuration type
const firebaseConfig = {
  apiKey: "AIzaSyAw0d_nvQ3X2KhQC6Bf_8zmMh-pHL_k2ps",
  authDomain: "salescodecoe-demo.firebaseapp.com",
  projectId: "salescodecoe-demo",
  storageBucket: "salescodecoe-demo.firebasestorage.app",
  messagingSenderId: "206379887853",
  appId: "1:206379887853:web:d12488d181e76f0d83b0e4",
  measurementId: "G-0S1YC2G8RX",
};

// niine prod firebase config (to be removed)
const niineFirebaseConfig = {
  apiKey: "AIzaSyAPipMXAh1Ybce86RpMJOrEhXY4ZgdHiVA",
  authDomain: "niine-17b51.firebaseapp.com",
  projectId: "niine-17b51",
  storageBucket: "niine-17b51.firebasestorage.app",
  messagingSenderId: "403014499858",
  appId: "1:403014499858:web:b25a6740a3ff12a692a2cb",
  measurementId: "G-EYZGXKKRBM"
};

// cavinkare prod firebase config (to be removed)
const cavinKareFirebaseConfig = {
  apiKey: "AIzaSyAm4ouHj584s8V-VKIlKjWXrH8947rhMn0",
  authDomain: "ck-prod-a8a40.firebaseapp.com",
  projectId: "ck-prod-a8a40",
  storageBucket: "ck-prod-a8a40.firebasestorage.app",
  messagingSenderId: "174391907504",
  appId: "1:174391907504:web:8b279a4d72496406f61775",
  measurementId: "G-847T03X2LQ"
};

const lob = getLob();
const configToUse = lob === "niine" ? niineFirebaseConfig : lob === "ckcoe" ? cavinKareFirebaseConfig : firebaseConfig;

// Initialize Firebase
const app = initializeApp(configToUse);

// Initialize Analytics
const analytics: Analytics = getAnalytics(app);

// Initialize Performance Monitoring
const performance: FirebasePerformance = getPerformance(app);

const logLoadTrace = async (functionToTrace:()=>any,name:string)=>{
  const pageLoadTrace: PerformanceTrace = trace(performance, name);
  const t = new Date();
  pageLoadTrace.start();
  try{
    await functionToTrace();
  }catch(e){}
  pageLoadTrace.stop();
  console.log(`${name} log traced: ${(pageLoadTrace as any).durationUs / 1000} ms`);
}

const logAnalyticsEvent = (eventName:string, eventParams:any)=>{
  console.log(`${eventName} log triggered: ${JSON.stringify(eventParams)}`);
  logEvent(analytics, eventName, eventParams);
}

// Export for use in other files
export { analytics, performance, logLoadTrace, logAnalyticsEvent };
